import { extend } from "vee-validate";
import {
  required,
  email,
  alpha_num as alphaNum,
  numeric,
} from "vee-validate/dist/rules";
import i18next from "i18next";
import { getDecimalSeparator } from "../helpers/languages";

extend("mandaa-number", {
  validate(value) {
    const decimalSeparator = getDecimalSeparator(i18next.language);
    const message = i18next.t("validationRules:frontend.mandaa_number", {
      decimalSeparator,
    });
    const priceRegEx = new RegExp(
      `^-?(\\d+(?:[${decimalSeparator}]\\d{1,2})?)$`
    );

    if (priceRegEx.test(value)) {
      return true;
    }
    return message;
  },
});

extend("mandaa-phone", {
  validate(value) {
    const message = i18next.t("validationRules:frontend.mandaa_phone");

    if (/^\+\d{1,5}[- ]?\d{1,15}$/.test(value)) {
      return true;
    }
    return message;
  },
});

extend("mandaa-password", (value) => {
  if (!/(?=(?:.*\d){1})/.test(value)) {
    return "validationRules:frontend.number";
  }

  if (!/(?=(?:.*[A-Z]){1})/.test(value)) {
    return "validationRules:frontend.uppercase";
  }

  if (!/(?=(?:.*[a-z]){1})/.test(value)) {
    return "validationRules:frontend.lowercase";
  }

  if (!/(?=(?:.*[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]){1})/.test(value)) {
    return "validationRules:frontend.symbol";
  }

  if (!/(?=.{8,})/.test(value)) {
    const message = i18next.t("validationRules:frontend.min", { length: 8 });
    return message;
  }
  return true;
});

extend("email", {
  ...email,
  message: () => {
    return "validationRules:frontend.email";
  },
});

extend("required", {
  ...required,
  message: () => {
    return "validationRules:frontend.required";
  },
});
extend("alpha_num", {
  ...alphaNum,
  message: () => {
    return "validationRules:frontend.alpha_num";
  },
});

extend("numeric", {
  ...numeric,
  message: () => {
    return "validationRules:frontend.numeric";
  },
});

extend("min", {
  params: ["length"],
  validate(value, { length }) {
    const message = i18next.t("validationRules:frontend.min", { length });
    if (value.length >= length) {
      return true;
    }
    return message;
  },
});

extend("password", {
  params: ["target"],
  validate(value, { target }: any) {
    if (value === target) {
      return true;
    }
    return "validationRules:frontend.confirm_password";
  },
});

extend("max", {
  params: ["length"],
  validate(value, { length }) {
    const message = i18next.t("validationRules:frontend.max", { length });
    if (value.length <= length) {
      return true;
    }
    return message;
  },
});

extend("dateAfterOrEqual", {
  params: ["target"],

  validate(value, { target }: any) {
    return value >= target;
  },
  message: "validationRules:frontend.afer_or_equal",
});
